import {useEffect, useState} from "react"

// The dashboard host floors the packaging iframe at `window.outerHeight` (see
// the dashboard's Packaging.tsx). The in-iframe layouts want to fill that floor
// so the sidebar reaches the footer — but they must use this *fixed px* value,
// NOT `100vh`.
//
// Why: in a content-sized iframe (height driven by a ResizeObserver -> postMessage),
// `vh` / `window.innerHeight` resolve to the iframe's *current* height. So once a
// tall page (a builder form) grows the iframe, `min-height: 100vh` anchors every
// later page to that grown height and the iframe never shrinks back. By contrast
// `window.outerHeight` reflects the browser window and stays constant (= the host's
// floor), so it both fills and lets the iframe shrink when content gets shorter.
export default function useIframeFloorHeight(): number {
    const read = () =>
        (typeof window !== "undefined" ? (window.outerHeight || window.innerHeight || 800) : 800)

    const [floor, setFloor] = useState<number>(read)

    useEffect(() => {
        const onResize = () => setFloor(read())
        window.addEventListener("resize", onResize)
        return () => window.removeEventListener("resize", onResize)
    }, [])

    return floor
}
